module.exports = __webpack_public_path__ + "img/af.d196903c.svg";